import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SidenavContentListComponent } from './sidenav-content-list.component';
import { MaterialModuleMobi } from '../material/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CdkDrag, CdkDropListGroup, DragDropModule } from '@angular/cdk/drag-drop';
import { WidgetPropertyFormsModule } from '../widgetPropertyForms/widget-property-forms.module';
import { StageModule } from '../stage/stage.module';
import { SharedModule } from 'shared-library';




@NgModule({
  declarations: [
    SidenavContentListComponent
  ],
  imports: [
    CommonModule,
    MaterialModuleMobi,
    FormsModule,  
    ReactiveFormsModule,
    DragDropModule,
    WidgetPropertyFormsModule,
    StageModule,
    CdkDropListGroup,
    DragDropModule,CdkDrag,
    SharedModule
  ],
  exports: [
    SidenavContentListComponent
  ]
})
export class SidenavContentListModule { }
